module.exports = __webpack_public_path__ + "static/media/8789.8e404345.png";